// ** Reducers Imports
import navbar from './navbar'
import layout from './layout'
import auth from './authentication'
import loader from './loader'



const rootReducer = {
  auth,
  navbar,
  layout,
  loader
}

export default rootReducer
